export default "__VITE_ASSET__43f5330d__"